// Data (AAAA-MM-DD) N dias úteis antes de outra, pulando sábados e domingos.
// Feriados não entram na conta. Mesma regra da API (AgendamentoLeadController::diasUteisAntes).
export function diasUteisAntes(dataIso, dias) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(dataIso || ''))) return '';
    const [a, m, d] = dataIso.split('-').map(Number);
    const data = new Date(Date.UTC(a, m - 1, d));
    let faltam = dias;
    while (faltam > 0) {
        data.setUTCDate(data.getUTCDate() - 1);
        const semana = data.getUTCDay();
        if (semana !== 0 && semana !== 6) faltam--;
    }
    return data.toISOString().slice(0, 10);
}
